import { render, staticRenderFns } from "./index.vue?vue&type=template&id=47323bf2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=47323bf2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47323bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\site\\online-photo\\image-upscaler-spa\\aiseesoft.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47323bf2')) {
      api.createRecord('47323bf2', component.options)
    } else {
      api.reload('47323bf2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=47323bf2&scoped=true", function () {
      api.rerender('47323bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/index.vue"
export default component.exports